import type { SubUnitInfo } from 'src/types/responses/getUnitsInfoResponse';
import type { AvailableSubUnit, AvailableSubUnits } from 'src/types/responses/usersAuthResponse';

/**
 * Adapter: cloud `/user/get_units_info` returns `sub_units` as `SubUnitInfo[]`,
 * but the rest of the app (login, profile switch, `Object.keys(...)` consumers)
 * expects the `AvailableSubUnits` record keyed by `unit_id`. Without this
 * mapping shared homes never reach the store as a usable shape.
 *
 * Kept dependency-free so it can be unit-tested without dragging the
 * design-system / svelte-i18n chain into Jest.
 */
export const mapSubUnitsInfoToAvailableSubUnits = (subUnits: SubUnitInfo[]): AvailableSubUnits =>
	Object.fromEntries(
		subUnits.map((entry) => [
			String(entry.unit_id),
			{
				sub: entry.sub_id,
				name: entry.name?.trim() || '',
				email: entry.shared_by?.trim() || undefined,
			} satisfies AvailableSubUnit,
		]),
	);
